

























































































import { Component, Vue } from 'vue-property-decorator';
import FlightClass from '@/store/entities/flight/flightClass';
import FlightSegment from '@/store/entities/flight/flightSegment';
import FlightQuota from '@/store/entities/flight/flightQuota';
@Component({})
export default class AddFlightQuotaModal extends Vue {
  dialog: boolean = true;

  flightClasses: FlightClass[] = [];
  flightSegments: FlightSegment[] = [];
  flightQuota: FlightQuota = new FlightQuota();
  created() {
    this.getFlightClasses();
    this.getFlightSegments();
  }

  async getFlightClasses() {
    await this.$store.dispatch({
      type: 'flightClass/getFlightClasses',
    });

    this.flightClasses = this.$store.state.flightClass.list;
  }

  async getFlightSegments() {
    await this.$store.dispatch({
      type: 'flightSegment/getFlightSegments',
    });

    this.flightSegments = this.$store.state.flightSegment.list;
  }

  data() {
    return {
      range: [0, 70],

      // flightClassItems:['Economy'],
      // flightClasses: [],

      // flightSegmentItems:['Y'],
      // flightSegments: [],
    };
  }

  closeDialog() {
    this.$emit('closed');
  }
}
